import * as React from 'react';
import {useEffect, useState} from "react";
import {useLocation, useParams} from "react-router-dom";
import {
    completeDocumentOnClient, getCustomerDocumentKey,
    getDocumentKey,
    getEsignProfiles,
    pendingCustomerDocumentOnClient
} from "../../../api";
import {useHistory} from "react-router";


const CompleteDocument: React.FunctionComponent = () => {
    const {clientId, documentId} = useParams();
    const history = useHistory();
    const [doRedirect, setDoRedirect] = useState(false);
    const [error, setError] = useState("");
    let location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const pendingCustomer = (queryParams.get("pending_customer") || "");
    const esignDocumentId = (queryParams.get("document_id") || "");


    useEffect(() => {

        if (pendingCustomer && pendingCustomer === "true") {
            getEsignProfiles()
                .then((ps) => {
                    let profile = ps.filter((p) => p.name === "Promises12")[0];
                    getCustomerDocumentKey(profile.uuid, documentId)
                        .then((k) => {
                            pendingCustomerDocumentOnClient(clientId, documentId, {
                                esignDocumentId: esignDocumentId,
                                esignDocumentKey: k.uuid,
                                esignProfileId: profile.uuid
                            })
                                .then((r) => {
                                    if (r.ok) {
                                        setDoRedirect(true)
                                    } else {
                                        setError("Unable to save document");
                                    }
                                }).catch((e) => {
                                setError("Unable to save document")
                            });
                        })
                        .catch(e => {
                            setError("Unable to save document")
                        })
                })
                .catch(e => {
                    setError("Unable to save document")
                });


        } else {
            completeDocumentOnClient(documentId)
                .then((r) => {
                    if (r.ok) {
                        setDoRedirect(true)
                    } else {
                        setError("Unable to save document");
                    }
                }).catch((e) => {
                setError("Unable to save document")
            })
        }
    }, [clientId, documentId, pendingCustomer]);

    useEffect(() => {
        if (doRedirect) {
            history.push({
                pathname: "/m/clients/view/" + clientId
            });
        }
    }, [doRedirect, clientId, history]);

    return (<p>
        <div hidden={error !== ""}>
            Saving document...
            <div className="spinner-grow text-primary" role="status">
                <span className="sr-only">Loading...</span>
            </div>
        </div>
        {error}
    </p>);
};

export default CompleteDocument;